import { cleanDialogStack } from '@patrianna/dialog-manager'
import { deleteCookie, setCookie } from '@patrianna/shared-utils/cookie'
import { isMobileScreenSize } from '@patrianna/shared-utils/helpers'
import { saveAndGetPaymentProviders } from '@patrianna-payments/shared-store/payments/store/actions'
import type { PaymentProviders } from '@patrianna-payments/shared-store/payments/types/api/PaymentProviders'
import { convertOpenApiErrorResponseToGateway } from '@patrianna-payments/shared-store/payments/utils/convertOpenApiErrorResponseToGateway'

import type { TypedThunk } from 'src/store/types'

import { actions } from './slice'

export const {
  toggleDarkTheme,
  togglePWAMessage,
  saveLocationData,
  savePasswordPolicy,
  saveUseImageBasedCaptcha,
  setForcementMode,
  setGoldCurrency,
  setSweepstakeEnabled,
  initApp,
  saveKYCRequiredField,
  saveThirdPartyCheckEnabled,
} = actions

export const openPreviewModePromo = (): TypedThunk => () => {
  const isMobile = isMobileScreenSize()

  if (!isMobile) {
    cleanDialogStack()
  }
}

export const getAvailablePaymentProvidersRequest =
  (): TypedThunk =>
  (dispatch, getState, { payment, errorHandler }) => {
    payment
      .getPaymentServiceInfo({})
      .then((response) => {
        const { withdrawProviders, purchaseProviders } = response as unknown as PaymentProviders
        const { thirdPartyCheckEnabled, softKycRequiredEnabled } = response

        dispatch(saveAndGetPaymentProviders({ withdrawProviders, purchaseProviders }))
        dispatch(saveThirdPartyCheckEnabled({ thirdPartyCheckEnabled }))
        dispatch(saveKYCRequiredField({ softKycRequiredEnabled }))
      })
      .catch(convertOpenApiErrorResponseToGateway('GetPaymentServiceInfoResponse'))
      .catch((err) => {
        dispatch(errorHandler(err, {}))
      })
  }

export const enabledSweepstake =
  (enabled: boolean): TypedThunk =>
  (dispatch) => {
    if (enabled) {
      setCookie('SC_ENABLED', '1')
    } else {
      deleteCookie('SC_ENABLED')
    }

    dispatch(setSweepstakeEnabled({ enabled }))
  }
